angular.module('zc.zenclerkS')
  .component('zcsMaintenance', {
    templateUrl: '/templates/zenclerk_s/directives/zcs_maintenance/zcs_maintenance.html',
    controllerAs: 'vm',
    controller: zcsMaintenanceController,
  });

zcsMaintenanceController.$inject = ['ZcsOemService'];
function zcsMaintenanceController(ZcsOemService) {
  const vm = this;
  vm.$onInit = () => {
    vm.ZcsOemService = ZcsOemService;
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/zcs_maintenance/zcs_maintenance.js